'use client';

import clsx from 'clsx';
import { headerStyle } from '../header.style';
import { Logo } from '@/components/core/logo';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { useRouter } from '@/navigation';
import { useLocale } from 'next-intl';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { KafkaNote } from '@nf/utils-common/constants';
import { ApiSiteNameEnums } from '@nf/types/site';
import { siteService } from '@/services/site.service';


export const HeaderLogo = () => {
	const router = useRouter();
	const locale = useLocale();

	const view = useAppearanceStore(state => state.view);
	const { SiteConfigsData } = useGetSiteConfigs();
	const isSampleSite = siteService.isMatchingSite(SiteConfigsData?.GetMessageID, ApiSiteNameEnums.SampleSite);

	const clickHandler = () => {
		setKafkaGalaxy();
		setKafkaMars();
		router.push(isSampleSite ? '/lobby' : '/live/1', { locale });
	}

	const setKafkaGalaxy = () => {
		if (view !== ViewEnum.galaxy) return;

		const kafkaData = {
			note: KafkaNote.GalaxyV2,
			type: 1,
			action: 2
		}
		setKafkaNormal(kafkaData);
	}

	const setKafkaMars = () => {
		if (view !== ViewEnum.mars) return;

		const kafkaData = {
			note: KafkaNote.MarsV1,
			type: 2,
			action: 12
		}
		setKafkaNormal(kafkaData);
	}

	return (
		<div
			className={clsx('header__logo', { [headerStyle.logo]: view === ViewEnum.mars })}
			onClick={clickHandler}
		>
			<Logo />
		</div>
	);
};